var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WsMain',[_c('AppGardenCalendar',{attrs:{"doneMode":true,"params":_vm._params}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }